import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × ÉTUDES STUDIO: Street minimalism and typographic geometry
// Bold typography, royal blue fields, linear forms
export function VasarelyEtudesMode({ brand }: ModeRendererProps) {
  return (
    <g>
      <defs>
        <linearGradient id="etudes-royal" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#0047AB" />
          <stop offset="50%" stopColor="#003D99" />
          <stop offset="100%" stopColor="#002F7A" />
        </linearGradient>
      </defs>

      {/* White background */}
      <rect x="0" y="0" width="794" height="1123" fill="#FFFFFF" />

      <g transform="translate(397 540)">
        {/* Royal blue fields */}
        {[
          { x: -350, y: -450, w: 200, h: 300 },
          { x: -100, y: -450, w: 150, h: 200 },
          { x: 100, y: -450, w: 250, h: 350 },
          { x: -350, y: -100, w: 180, h: 250 },
          { x: 50, y: -50, w: 300, h: 200 },
          { x: -350, y: 200, w: 250, h: 300 },
        ].map((field, i) => (
          <rect
            key={i}
            x={field.x}
            y={field.y}
            width={field.w}
            height={field.h}
            fill="url(#etudes-royal)"
            opacity="0.12"
          />
        ))}

        {/* Bold typography structure */}
        {[
          { text: "É", x: -200, y: -200, size: 180 },
          { text: "T", x: 0, y: -100, size: 140 },
          { text: "U", x: -100, y: 100, size: 160 },
          { text: "D", x: 100, y: 50, size: 120 },
          { text: "E", x: -50, y: -50, size: 100 },
          { text: "S", x: 150, y: -150, size: 110 },
        ].map((letter, i) => (
          <text
            key={i}
            x={letter.x}
            y={letter.y}
            fontFamily="Arial Black, sans-serif"
            fontSize={letter.size}
            fill="#0047AB"
            opacity="0.08"
            fontWeight="900"
            textAnchor="middle"
          >
            {letter.text}
          </text>
        ))}

        {/* Linear forms grid */}
        {Array.from({ length: 20 }).map((_, i) => {
          const x = -350 + i * 35;
          return (
            <line
              key={`v-${i}`}
              x1={x}
              y1="-450"
              x2={x}
              y2="450"
              stroke="#0047AB"
              strokeWidth="1"
              opacity="0.1"
            />
          );
        })}

        {Array.from({ length: 26 }).map((_, i) => {
          const y = -450 + i * 35;
          return (
            <line
              key={`h-${i}`}
              x1="-350"
              y1={y}
              x2="350"
              y2={y}
              stroke="#0047AB"
              strokeWidth="1"
              opacity="0.1"
            />
          );
        })}

        {/* Art publishing grid */}
        <rect x="-250" y="-300" width="500" height="600" fill="none" stroke="#0047AB" strokeWidth="3" />
        <rect x="-240" y="-290" width="480" height="580" fill="none" stroke="#0047AB" strokeWidth="1" opacity="0.5" />

        {/* Central bold element */}
        <rect x="-120" y="-120" width="240" height="240" fill="#0047AB" opacity="0.15" />
        <text
          x="0"
          y="20"
          fontFamily="Arial Black, sans-serif"
          fontSize="80"
          fill="#0047AB"
          opacity="0.8"
          fontWeight="900"
          textAnchor="middle"
        >
          É
        </text>

        {/* Geometric accent lines */}
        {Array.from({ length: 8 }).map((_, i) => {
          const angle = (i * Math.PI) / 4;
          return (
            <line
              key={i}
              x1="0"
              y1="0"
              x2={Math.cos(angle) * 280}
              y2={Math.sin(angle) * 280}
              stroke="#0047AB"
              strokeWidth="2"
              opacity="0.15"
            />
          );
        })}
      </g>

      {/* Street minimalism */}
      <text x="397" y="1010" textAnchor="middle" fontFamily="Arial Black, sans-serif" fontSize="11" fill="#0047AB" fontWeight="900" letterSpacing="3">
        GRAPHIC GEOMETRY
      </text>
    </g>
  );
}
